export const AD_TEAM_ENTITY_TYPE_OPTIONS = [
    { value: 0, labelKey: 'teams.adminPage.fields.ad_team_entity_type_fl' },
    { value: 1, labelKey: 'teams.adminPage.fields.ad_team_entity_type_ip' },
    { value: 2, labelKey: 'teams.adminPage.fields.ad_team_entity_type_llc' },
    { value: 3, labelKey: 'teams.adminPage.fields.ad_team_entity_type_self' },
] as const;

export const AD_DOMAIN_OPTIONS = [
    { value: 'hse', labelKey: 'teams.adminPage.fields.advertisement_domain_hse' },
    { value: 'others', labelKey: 'teams.adminPage.fields.advertisement_domain_others' },
] as const;

export const DEFAULT_AD_DOMAIN = 'hse';

const HSE_URL_ENV_KEYS = [
    'REACT_APP_URL_HSEDESIGN_COM',
    'REACT_APP_URL_HSE_SPACE',
    'REACT_APP_URL_CREATIVE_CITY',
    'REACT_APP_URL_HSEDESIGN_LMS',
    'REACT_APP_URL_HSEDESIGN_START_COM',
    'REACT_APP_URL_EXAMS_COM',
    'REACT_APP_URL_DESIGNSCHOOL_AM',
    'REACT_APP_URL_HSEDESIGN_PRO_RU',
];

const extractHost = (url: string | undefined): string | null => {
    if (!url) return null;
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    } catch {
        return null;
    }
};

const HSE_HOSTNAMES = new Set<string>([
    'dafes.net',
    ...HSE_URL_ENV_KEYS
        .map(k => extractHost(process.env[k]))
        .filter((h): h is string => !!h),
]);

export const resolveAdDomain = (): 'hse' | 'others' => {
    if (typeof window === 'undefined') return 'others';
    const host = window.location.hostname.replace(/^www\./, '');
    return HSE_HOSTNAMES.has(host) ? 'hse' : 'others';
};

export const createEmptyAdTeam = () => ({
    entityType: 0,
    isOperator: false,
    isDistributor: false,
    inn: '',
    name: '',
    email: '',
    phone: '',
    kpp: '',
    url: '',
    ordSystem: '',
    ordId: '',
    status: 0,
});
export const AD_TEAM_ENTITY_TYPE_OPTIONS = [
    { value: 0, labelKey: 'teams.adminPage.fields.ad_team_entity_type_fl' },
    { value: 1, labelKey: 'teams.adminPage.fields.ad_team_entity_type_ip' },
    { value: 2, labelKey: 'teams.adminPage.fields.ad_team_entity_type_llc' },
    { value: 3, labelKey: 'teams.adminPage.fields.ad_team_entity_type_self' },
] as const;

export const AD_DOMAIN_OPTIONS = [
    { value: 'hse', labelKey: 'teams.adminPage.fields.advertisement_domain_hse' },
    { value: 'others', labelKey: 'teams.adminPage.fields.advertisement_domain_others' },
] as const;

export const DEFAULT_AD_DOMAIN = 'hse';

const HSE_URL_ENV_KEYS = [
    'REACT_APP_URL_HSEDESIGN_COM',
    'REACT_APP_URL_HSE_SPACE',
    'REACT_APP_URL_CREATIVE_CITY',
    'REACT_APP_URL_HSEDESIGN_LMS',
    'REACT_APP_URL_HSEDESIGN_START_COM',
    'REACT_APP_URL_EXAMS_COM',
    'REACT_APP_URL_DESIGNSCHOOL_AM',
    'REACT_APP_URL_HSEDESIGN_PRO_RU',
];

const extractHost = (url: string | undefined): string | null => {
    if (!url) return null;
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    } catch {
        return null;
    }
};

const HSE_HOSTNAMES = new Set<string>([
    'dafes.net',
    ...HSE_URL_ENV_KEYS
        .map(k => extractHost(process.env[k]))
        .filter((h): h is string => !!h),
]);

export const resolveAdDomain = (): 'hse' | 'others' => {
    if (typeof window === 'undefined') return 'others';
    const host = window.location.hostname.replace(/^www\./, '');
    return HSE_HOSTNAMES.has(host) ? 'hse' : 'others';
};

export const createEmptyAdTeam = () => ({
    entityType: 0,
    isOperator: false,
    isDistributor: false,
    inn: '',
    name: '',
    email: '',
    phone: '',
    kpp: '',
    url: '',
    ordSystem: '',
    ordId: '',
    status: 0,
});
